<template>
  <v-container class="grey lighten-5" v-if="user">
    <h1>Nutzer: {{ user.username }}</h1>
    <br/>
    <div v-if="!isNew">
      <h2>Aktionen</h2>
      <v-row no-gutters>
        <v-btn @click="resetPassword" class="ma-2" outlined color="indigo">Passwort
          Zurücksetzen
        </v-btn>
        <div style="width: 24px"/>
        <v-text-field v-if="isAdmin" v-model="temporaryPassword" label="Temporäres Passwort"/>
        <v-btn v-if="isAdmin" @click="setTemporaryPassword" :disabled="temporaryPassword.length===0" class="ma-2"
               outlined
               color="indigo">Temporäres Passwort setzen
        </v-btn>
      </v-row>
      <br/>
      <br/>
    </div>
    <h2>Allgemeine Informationen</h2>

    <div v-if="superAdmin">
      <div v-if="user.isAdminOfCompany">
        <v-chip style="margin-top: 8px; margin-bottom: 16px" class="ma-2" color="primary" label>
          <v-icon left>mdi-account-circle-outline</v-icon>
          Administrator der Firma {{ user.companyName }}
        </v-chip>
        <v-btn @click="degradeUser" class="ma-2" outlined color="indigo">Berechtigung ändern auf Nutzer
        </v-btn>
      </div>
      <div v-else>
        <v-chip style="margin-top: 8px; margin-bottom: 16px" class="ma-2" color="secondary" label>
          <v-icon left>mdi-account-circle-outline</v-icon>
          Nutzer der Firma {{ user.companyName }}
        </v-chip>
        <v-btn @click="promoteUser" class="ma-2" outlined color="indigo">Berechtigung ändern auf Admin
        </v-btn>
      </div>
    </div>
    <v-text-field v-model="user.username" label="Nutzername" :disabled="!isNew"/>
    <v-text-field v-model="user.name" label="Vorname"/>
    <v-text-field v-model="user.surname" label="Nachname"/>
    <v-text-field v-model="user.email" label="E-Mail"/>
    <v-checkbox v-model="user.isActive" label="Aktiv"/>
    <div v-if="company.departments.length>0">
      <h4>Abteilungen</h4>
      <v-autocomplete
          clearable
          multiple
          outlined
          persistent-hint
          small-chips
          solo
          :items="company.departments"
          v-model="user.companyDepartments"
          label="Departments"
      />
    </div>
    <br/>
    <br/>
    <h2>Schulungsspezifische Informationen</h2>
    <v-text-field
        v-model="newBirthDate"
        :disabled="!isAdmin && !superAdmin"
        label="Geburtstag"
        persistent-hint
        prepend-icon="mdi-calendar"
        hint="[DD.MM.YYYY]"
    />

    <v-text-field
        style="margin-top: 16px"
        v-model="newZVUExp"
        persistent-hint
        :disabled="!isAdmin && !superAdmin"
        hint="[DD.MM.YYYY]"
        label="Ablaufdatum der Zuverlässigkeitsüberprüfung (ZVÜ)"
        prepend-icon="mdi-calendar"
    />

    <v-checkbox :disabled="!isAdmin && !superAdmin" v-model="user.isHimself" :label="isSelfText"/>
    <div v-if="superAdmin && !isNew && user.syncProblemEntries && user.syncProblemEntries.length > 0" style="margin-top: 24px">
      <h2>Problem bei der Kurs-Synchronisierung</h2>
      <v-alert
          v-for="entry in user.syncProblemEntries"
          :key="entry.id"
          type="warning"
          dense
          outlined
          style="margin-top: 12px"
      >
        <strong>{{ entry.title }}</strong><br>
        Letzter bestaetigter Sync: {{ entry.lastSyncLabel }}<br>
        Status: {{ entry.syncRiskLabel }}<br>
        Resume-State gespeichert: {{ entry.hasPersistedState ? "Ja" : "Nein" }}
        <div v-if="superAdmin" style="margin-top: 12px">
          <v-btn
              small
              outlined
              color="warning"
              :loading="resumeStateActionId === entry.id"
              :disabled="resumeStateActionId === entry.id || !entry.hasPersistedState"
              @click="clearResumeState(entry)"
          >
            Resume-State löschen
          </v-btn>
        </div>
      </v-alert>
    </div>
    <v-btn class="ma-1" :loading="loading" :disabled="loading" color="info" @click="save">
      <div v-if="isNew">Anlegen</div>
      <div v-else>Speichern</div>
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>
  </v-container>
</template>

<script>
import User from "@/models/User";
import moment from "moment";

export default {
  name: "UserEdit",
  props: {
    superAdmin: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String
    },
    companyId: {
      type: String,
      default: null
    }
  },
  computed: {
    isNew() {
      return this.userId === "-1";
    },
    isSelfText() {
      return "In meiner Funktion als Sicherheitsbeauftragter bestätige ich, dass die Zugangsdaten ausschließlich an den zu schulenden Teilnehmer übergeben werden und die Personenidentität mindestens einmal pro Schulungstag überprüft und protokolliert wird."
    },
  },
  data: () => ({
    isAdmin: false,
    errorText: "",
    error: false,
    success: false,
    showBirthdate: false,
    newBirthDate: "",
    showZVU: false,
    newZVUExp: "",
    loading: false,
    resumeStateActionId: null,
    successText: "",
    temporaryPassword: "",
    user: {
      type: User
    },
    company: {
      departments: []
    }
  }),
  mounted() {
    this.load()
  },
  methods: {
    errorCb() {
      this.errorText = "Fehler."
      this.error = true;
      this.loading = false;
      setTimeout(() => this.error = false, 3000);
    },
    successCb() {
      this.successText = "Erfolgreich."
      this.error = false;
      this.success = true;
      this.loading = false;
      setTimeout(() => this.error = false, 3000);
      this.load()
    },
    promoteUser() {
      this.$httpUserApi.promoteUser(this.userId, () => this.successCb(), () => this.errorCb())
    },
    degradeUser() {
      this.$httpUserApi.degradeUser(this.userId, () => this.successCb(), () => this.errorCb())
    },
    setTemporaryPassword() {
      this.resetPassword(true)
    },
    load() {
      if (!this.isNew) {
        this.$httpUserApi.getUser(this.userId, (data) => {
          this.user = data;
          if (data.birthdateMoment.isValid()) {
            this.newBirthDate = data.birthdateMoment.format("DD.MM.YYYY");
          } else {
            this.newBirthDate = "";
          }
          if (data.zvuMoment.isValid()) {
            this.newZVUExp = data.zvuMoment.format("DD.MM.YYYY");
          } else {
            this.newZVUExp = ""
          }
          this.$httpCompanyApi.get(data.companyId, (company) => {
            this.company = company;
            this.$httpUserApi.get((user) => {
              this.isAdmin = user.isAdminOrSuperAdmin();
            })
          });
        })
      } else {
        this.user = new User({isActive: true, isAdmin: true})
        this.isAdmin = true;
        if (this.companyId === null) {
          this.$httpCompanyApi.getMyCompany((company) => {
            this.company = company;
          });
        } else {
          this.company = {id: this.companyId, departments: []}
        }
      }
    },
    save() {
      if (!this.user.isValid()) {
        this.errorText = "Bitte Usernamen, Namen sowie E-Mail überprüfen.";
        this.error = true;
        setTimeout(() => this.error = false, 5000);
        return
      }
      let sendItem = Object.assign({}, this.user);
      let zvuMoment = moment(this.newZVUExp, "DD.MM.YYYY", true)
      let birthdateMoment = moment(this.newBirthDate, "DD.MM.YYYY", true)
      if ((!zvuMoment.isValid() && this.newZVUExp.length > 0) || (!birthdateMoment.isValid() && this.newBirthDate.length > 0)) {
        this.errorText = "Bitte Datumsformate überprüfen.";
        this.error = true;
        setTimeout(() => this.error = false, 5000);
        return
      }

      sendItem.zvuExpirationDate = zvuMoment.toISOString()
      sendItem.birthdate = birthdateMoment.toISOString()
      if (this.superAdmin && this.companyId !== null) {
        sendItem.companyId = this.companyId;
      } else {
        sendItem.companyId = this.company.id;
      }
      this.loading = true;
      let callbackSuccess = () => {
        this.successText = "Gespeichert."
        this.success = true;
        this.loading = false;
        setTimeout(() => this.success = false, 3000);
        this.$emit("reload")
      };
      let callbackError = (callbackError) => {
        console.log(callbackError);
        this.errorText = callbackError.response.data.message
        this.error = true;
        this.loading = false;
        setTimeout(() => this.error = false, 3000);
      }
      if (this.isNew) {
        this.$httpUserApi.createUser(sendItem, (user) => {
          callbackSuccess();
          this.$emit("finish", user)
        }, callbackError)
      } else {
        this.$httpUserApi.updateUser(sendItem, callbackSuccess, callbackError)
      }
    },
    resetPassword(temporary) {
      let success = () => {
        this.successText = "Erfolgreich."
        this.success = true;
        setTimeout(() => this.success = false, 3000);
      }
      let error = () => {
        this.errorText = "Fehler."
        this.error = true;
        setTimeout(() => this.error = false, 3000);
      }
      if (temporary) {
        this.$httpUserApi.setTemporaryPassword(this.userId, this.temporaryPassword, success, error)
      } else {
        this.$httpUserApi.resetPassword(this.userId, success, error)
      }
    },
    clearResumeState(entry) {
      if (!window.confirm("Gespeicherten Resume-State fuer diesen Kursstand wirklich loeschen? Fortschritt und Zertifikate bleiben erhalten.")) {
        return;
      }

      this.resumeStateActionId = entry.id;
      this.$httpUserApi.clearCourseResumeState(this.userId, entry.courseRunId, entry.partId, () => {
        this.resumeStateActionId = null;
        this.successText = "Resume-State geloescht."
        this.success = true;
        setTimeout(() => this.success = false, 3000);
        this.load();
        this.$emit("reload")
      }, (err) => {
        this.resumeStateActionId = null;
        this.errorText = err?.response?.data?.message || "Fehler beim Loeschen des Resume-State."
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    }
  }
}
</script>

<style scoped>

</style>
